export default __webpack_public_path__ + "static/media/logo-white.da99592b.svg";